import style from './Styles/SasriaTheme.scss';

export default {
    name: 'SasriaTheme',
    prefix: 'sasriaTheme',
    rootStyle: {
        
        '--GW-COLOR-BRAND-2': 'rgb(30, 30, 30)',
        '--GW-COLOR-BRAND-1': 'rgb(237, 41, 57)',
        '--GW-COLOR-ALERT-ERROR': 'rgb(237, 41, 57)',
        '--GW-COLOR-BRAND-1-ACTIVE': 'rgb(237, 41, 57)',
        '--GW-COLOR-BRAND-1-HOVER': 'rgb(30, 30, 30)',
        '--GW-COLOR-BRAND-1-GRADIENT-HOVER': 'rgb(30, 30, 30)',
        '--GW-COLOR-BRAND-1-ACTIVE': 'rgb(30, 30, 30)',
        '--GW-COLOR-BRAND-1-GRADIENT': 'rgb(237, 41, 57)',
        '--GW-COMPONENT-BOX-SHADOW': '`38px` `15px` `5px` `0px` rgba(0, 0, 0, 0.75)',
        '--GW-COLOR-BACKGROUND-1': 'rgb(255, 255, 255)',
        '--GW-COLOR-BACKGROUND-2': 'rgb(255, 255, 255)',
       '--GW-COLOR-LINK-1': 'rgb(237, 41, 57)' ,   
       // '--button-hover-bg-color':  'rgb(30, 30, 30)',
        '--GW-FONT-SANS-SERIF': '"Geneva Regular","Arial Regular", sans-serif',
        '--GW-FONT-FAMILY': '"Arial Regular", sans-serif',
        '--input-font-family': '"Arial Regular", sans-serif',
        '--GW-COLOR-ALERT-INFO': 'rgb(237, 41, 57)',
        '--GW-COLOR-ALERT-INFO-CONTRAST': 'rgb(255, 255, 255)',
        '--GW-COLOR-LINK-1-ACTIVE': 'rgb(237, 41, 57)'
                      
    },
    componentStyles: {
        Wizard: {
            wizardTitle: {}
        },
        Button: {
            button: {}
        }
    }
   
    // componentStyles: {
    //     Button: {
    //         button: {
    //             //'--button-height': '`20px`',
    //             //'box-shadow': 'var(--GW-COMPONENT-BOX-SHADOW)',
    //            // '--button-bg-color': 'rgb(237, 41, 57)'
    //         }
    //     }
    // }
};
